import {
  Delete,
  Get,
  getAPIUrl,
  Post,
  Put,
} from "../../../ApiServices/apiMethod";
import { HomePageService } from "../../../ApiServices/Axios/Index";

export const SubscribersEndpoint = {
  getSubscribers: `/admin/newsLetter/list`,
  deleteSubscriber: `/admin/newsLetter/delete/`,
  addSubscribers: `/admin/newsLetter/add`,
};

export const getSubscribers = (param = "") => {
  const url = getAPIUrl(SubscribersEndpoint.getSubscribers, param);
  return Get(HomePageService, url, true);
};

export const addSubscribers = (data, param = "") => {
  const url = getAPIUrl(SubscribersEndpoint.addSubscribers, param);
  return Post(HomePageService, url, data, true);
};

export const deleteSubscriber = (param = "") => {
  const url = getAPIUrl(SubscribersEndpoint.deleteSubscriber, param);
  return Delete(HomePageService, url, param);
};
